import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../hooks/use-services.hook";
import {PersonGroupIcon} from "../../assets/svg/person-group.icon";
import {CustomDropDownComponent} from "../drop-down/custom-drop-down.component";
import {PassengersTypesDropDownHeaderComponent} from "./header/passengers-types-drop-down-header.component";
import {PassengersTypesDropDownListComponent} from "./list/passengers-types-drop-down-list.component";
import {IDropDownController} from "../drop-down/drop-down-controller.interface";

export const PassengersTypesDropDownComponent: React.FC = observer(() => {
    const services = useServices();
    //const [isOpen, setIsOpen] = useState(false);
    const fields = services.flightSearch.searchController.fields;

    const onOpen = () => {
        //setIsOpen(true);
    }

    const onClose = () => {
        //setIsOpen(false);
    }

    const renderHeader = () => {
        return (
            <PassengersTypesDropDownHeaderComponent/>
        );
    }

    const renderList = (dropDownController: IDropDownController) => {
        return (
            <PassengersTypesDropDownListComponent dropDownController={dropDownController}/>
        );
    }
    return (
        <CustomDropDownComponent label={fields.passengers.fieldName}
                                 icon={<PersonGroupIcon/>}
                                 errorMessage={fields.passengers.error}
                                 renderInput={renderHeader}
                                 onOpen={onOpen}
                                 onClose={onClose}
                                 renderList={renderList}/>
    )
})
